import React, {useState} from "react";
import {NavLink} from "react-router-dom";
import ContentBox from "../../../../../../components/content-box/ContentBox";
import PageActions from "../../../../../base/PageActions";
import Breadcrumbs from "../../../../../../components/breadcrumbs/Breadcrumbs";
import Modal from "../../../../../../components/modal/Modal";
import _image_service from "../../../../../../services/ImageService";
import '../../../../../styles/Common.scss';
import '../../WorldPages.scss';
import '../../WorldDynamicContent.scss';

interface ModernHistoryPageProps {
}

const ModernHistoryPage = (props: ModernHistoryPageProps) => {

    const _map_src = `chase/world/geography/casarok_modern.png`;

    const page: PageActions = new PageActions({
        title: `Casarok History: Modern Age - Chase the Fox`,
        description: "The modern age of Casarok is a time of relative peace following a war that engulfed the world!",
        keywords: ["casarok", "casarok history", "modern age", "fantasy timeline", "fantasy world history", "modern fantasy", "fantasy modern age"],
        imgSrc: _map_src,
        url: `world/history/modern-age`
    });

    const [modalIsOpen, setModalIsOpen] = useState<boolean>(false);

    return page.generateMetaContent(
        <>
            <Modal isOpen={modalIsOpen}
                   onClose={() => setModalIsOpen(false)}>
                <div className="geography-modal-view">
                    <p className="center">
                        <a href={_image_service.getCdnImageSrc(_map_src, 'full')}
                           target="_blank"
                           rel="noopener noreferrer">
                            Click here to view the full size image.
                        </a>
                    </p>
                    <img src={_image_service.getCdnImageSrc(_map_src, 'desktop')}
                         title='Modern Casarok Political Map'
                         alt="A map of Casarok's countries in the Modern Age"/>
                </div>
            </Modal>
            <ContentBox header="The Modern Age of Casarok">
                <Breadcrumbs path={page.getUrl()}/>
                <div className="world-page-static">
                    <a id="visible-element"
                       className="switch-visible geography-modal-link"
                       onClick={() => setModalIsOpen(true)}>
                        <img className="block width-50-percent"
                             src={_image_service.getCdnImageSrc(_map_src)}
                             alt="A map of Casarok's countries in the Modern Age"
                             title="Modern Casarok Political Map"/>
                    </a>
                </div>
                <div className="world-page-static">
                    <p className="center">
                        <em>This age covers the years 1900 - 2100 ACE.</em>
                    </p>
                    <p>
                        The Modern Age of Casarok comes off the heels of the world being ensnared
                        in <NavLink className="world-link" to='../machination-age'>the Machinization War</NavLink> of
                        the previous century. The Reverie Economic Zone was established as a neutral state to help
                        maintain the relative peace that signifies this age. It is still a point of contention for
                        countries that do not support its purpose, but more countries have joined its mission of peace
                        as the age progressed. The technological advancements from the previous age were applied in
                        less destructive ways.
                    </p>
                    <p>
                        <em>How does Casarok's Modern Age differ from the current day on Earth?</em><br/>
                        Technology is more advanced, almost to the realm of super-science. Robots and mechs are more
                        common in development, though they are not widespread or fully developed yet. Artificial
                        intelligence has not yet reached the level of maturity needed to create fully functional
                        androids. However, robots are capable of performing large-scale tasks like construction. Nanites
                        also are available throughout this age and have been used mostly in medical purposes, such as
                        treating microtism and macrotism in those affected by those birth defects. When smartphones
                        were invented, they would come packed with mage-tech that provides magic shields to prevent
                        gun violence and minor monster deterrents that help keep away weaker monsters, though do not
                        work to the same capacity as full-scale wards.
                    </p>
                    <h3 className="headline">Notable Events</h3>
                    <ul className="spaced">
                        <li>
                            <em>1904</em>: The Tillandic Civil War occurred, ending with the nation once again split
                            between North and South Tilland.
                        </li>
                        <li>
                            <em>1912</em>: The Association for the Trading Nations of Casarok is established in the
                            Zone of the Reverie to monitor the world's economy, regulate trade, and resolve such
                            disputes between nations.
                        </li>
                        <li>
                            <em>1923</em>: The Origin Overwatch is established in the Zone of the Reverie in response
                            to disruptions coming from Origin Mountain and the Eldwood to monitor those locations
                            of powerful magic and maintain public safety worldwide in response to archaic threats.
                        </li>
                        <li>
                            <em>1939</em>: Loagata establishes its independence from the multi-island spanning nation
                            of Rankin.
                        </li>
                        <li>
                            <em>1941</em>: The Anthro Health Services Organization is established in the Zone of the
                            Reverie to regulate healthcare and monitor infectious diseases after the age's first
                            pandemic. Along with the Federation of Sovereign States, the Internation Council of Magic,
                            and the other organizations established in previous decades, the Guiding Star of Casarok is
                            fully formed.
                        </li>
                        <li>
                            <em>1958</em>: A team of anthro astronauts from Haluthe become the first to set foot on the
                            moon.
                        </li>
                        <li>
                            <em>1972</em>: The small island nation of Ali'te establishes its independence from Rankin.
                        </li>
                        <li>
                            <em>1991</em>: The personal assistant was invented, which would soon pave way to the
                            development of the smartphone.
                        </li>
                        <li>
                            <em>2002</em>: Smartphone adoption starts becoming widespread. The Federation of Sovereign
                            States mandates that all future smartphones be equipped
                            with <NavLink className="world-link" to='/world/magic/items/bulletguard'>bulletguard</NavLink> and
                            personal <NavLink className="world-link" to='/world/magic/items/ward'>ward</NavLink> mage-tech.
                        </li>
                        <li>
                            <em>2019</em>: The events of <NavLink className="world-link" to='/comics/talechasers'>Tale
                            Chasers</NavLink> begins.
                        </li>
                        <li>
                            <em>2057</em>: The invention of personal spacecraft that allows for travel to orbit and the
                            moon.
                        </li>
                        <li>
                            <em>2070</em>: Colonies start to be established on other planets within Casarok's planetary
                            system. Settlers begin the magical terraforming of these planets.
                        </li>
                        <li>
                            <em>2092</em>: Personal spacecraft becomes more widespread and are capable of taking anthros
                            beyond the moon and into the rest of the planetary system.
                        </li>
                    </ul>
                </div>
            </ContentBox>
        </>
    );
}

export default ModernHistoryPage;